export function isBrowser(): boolean {
  return 'window' in globalThis;
}
